import { gql } from '@apollo/client';

const getPlantOrderQuery = gql`
    query getPlantOrder {
        plantOrder: plant_order {
            order
        }
    }
`;

export default getPlantOrderQuery;
